import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import ListHeader from 'shell/components/shared/list-header';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { FrontOfficeAuthorizations } from 'shell/authorizations/front-office';
import { useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import { useEventCallback } from '@mui/material';
import FilterAmount from 'front-office/components/amount/research/filter';
import { validationSchema } from 'front-office/constants/research-amount-schema';
import { ResearchAmountCrubs } from 'front-office/constants/amount-crubs';
import TableAmount from 'front-office/components/amount/research/table-amount';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { transformerListAmount } from 'front-office/utils/transformer-list-amount';
import { ResponseAmount } from 'shell/models/response-amount';
import { ResearchAmountVM } from 'front-office/view-models/research-amount';
import { transformDataset } from 'front-office/utils/transform-dataset-filter-list-amount';

const authsObj = Object.freeze({
  read: [FrontOfficeAuthorizations.RicercaImporto],
  create: [FrontOfficeAuthorizations.NuovoImporto],
  edit: [FrontOfficeAuthorizations.ModificaImporto],
  delete: [FrontOfficeAuthorizations.EliminaImporto],
});

const ResearchAmount = (): React.ReactElement => {
  const auths = useActionAuthorization(authsObj);

  const [list, getList] = useHttpFetch<HttpResponseList<ResponseAmount>, ResearchAmountVM>(
    `${__CERTIFICATION_API_URL__}/certificazione/importo-pagamento`,
    {
      onBootstrap: false,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformerListAmount,
    }
  );

  const navigate = useNavigate();

  const onSubmitFilter = useEventCallback((values: ResearchAmountVM) => {
    const queryString = transformDataset(values);

    getList({
      params: {},
      paramsSerializer: () => queryString,
    });
  });

  return (
    <Fragment>
      <Breadcrumbs items={ResearchAmountCrubs} />
      <ListHeader
        addBtnAriaLabel="Aggiungi nuovo Importo pagamento"
        addBtnLabel="Aggiungi nuovo Importo pagamento"
        canAdd={auths.create}
        onAddBtnClick={() => {
          navigate('/sportello/ricerca-importo/nuovo');
        }}
        title="Gestione Importo Pagamento"
      />
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          code: undefined,
          description: undefined,
          dateFrom: null,
          dateTo: null,
        }}
        onSubmit={onSubmitFilter}
      >
        <Form>
          <div className="pmi-my-3">
            <FilterAmount />
            {list ? (
              <TableAmount
                data={list.data as ResearchAmountVM}
                onSubmitFilter={onSubmitFilter}
                activeDelete={auths.delete}
                activeEdit={auths.edit}
              />
            ) : undefined}
          </div>
        </Form>
      </Formik>
    </Fragment>
  );
};

ResearchAmount.displayName = 'Research Amount component';

export default ResearchAmount;
